// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"2f552e5b","870":"af79bbde"}[chunkId] + ".chunk.js";
};